<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1 max-w-1400">
        <img :src="importedImg1" alt="" class="imgItem1" />
      </div>
    </div>
    <div class="imgBox2 min-w-1400">
      <div class="img2 max-w-1400">
        <img :src="importedImg2" :alt="altText" class="imgItem2" />
      </div>
    </div>

    <div class="imgBox6 min-w-1400">
      <div class="img6 max-w-1400">
        <div class="image-row">
          <router-link to="/" tag="li" class="a1">
            <a href=""><img :src="importedImg6" alt="" /></a>
          </router-link>
          <router-link to="/about" tag="li" class="a2">
            <a href=""><img :src="importedImg8" alt="" /></a>
          </router-link>
          <router-link to="/questions" tag="li" class="a3">
            <a href=""><img :src="importedImg9" alt="" /></a>
          </router-link>
          <router-link to="/protocol" tag="li" class="a4">
            <a href=""><img :src="importedImg10" alt="" /></a>
          </router-link>
        </div>
        <!-- 使用 Flex 布局，水平排列三个大标题 -->
        <div class="titlesContainer">
          <div class="titleContainer1">
            <p>บริษัทอยู่ในทำเลที่ดีและกู้ยืมได้รวดเร็ว</p>
            <div class="subtitles">
              <ul class="ul1">
                <li>SUBKAMOL LEASING COMPANY LIMITED</li>
                <li>
                  160/251 Saeng Chooto Road 71000 <br />
                  MUEANG KANCHANABURI
                </li>
              </ul>
            </div>
          </div>

          <div class="titleContainer2">
            <p>เบอร์ติดต่อ</p>
            <!-- 第二个大标题下的小标题 -->
            <div class="subtitles">
              <ul class="ul2">
                <li tag="li" class="triangle">+66 832834932</li>
                <li tag="li" class="triangle">office@subkamolplus.com</li>
              </ul>
            </div>
          </div>

          <div class="titleContainer3">
            <p>เวลาทำการ</p>
            <!-- 第二个大标题下的小标题 -->
            <div class="subtitles">
              <ul class="ul3">
                <li tag="li" class="triangle">
                  วันจันทร์ถึงวันศุกร์ 8.30 น. ถึง 17.00 น.
                </li>
                <li tag="li" class="triangle">
                  วันเสาร์ 09.00-16.30 น. <br />
                  (เปิดวันเสาร์ที่สองและสุดท้ายของเดือน)
                </li>
              </ul>
            </div>
          </div>
          <div class="titleContainer4">
            <p>เกี่ยวกับเรา</p>
            <!-- 第四个大标题下的小标题 -->
            <div class="subtitles">
              <ul class="ul4">
                <li tag="li" class="triangle">นโยบายความเป็นส่วนตัว</li>
                <li tag="li" class="triangle">รางวัลและความสำเร็จ</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="imgBox7 min-w-1400">
      <div class="img7 max-w-1400">
        <img :src="importedImg7" :alt="altText" class="imgItem7" />
      </div>
    </div> -->
  </div>
</template>

<script>
import "./index.css";
import importedImg1 from "@/page/subkamolplus/components/img/4_1.png";
import importedImg2 from "@/page/subkamolplus/components/img/4_2.png";

import importedImg6 from "@/page/subkamolplus/components/img/btn1.png";
import importedImg7 from "@/page/subkamolplus/components/img/footer.png";
import importedImg8 from "@/page/subkamolplus/components/img/btn2.png";
import importedImg9 from "@/page/subkamolplus/components/img/btn3.png";
import importedImg10 from "@/page/subkamolplus/components/img/btn4.png";
export default {
  data() {
    return {
      importedImg1: importedImg1,
      importedImg2: importedImg2,

      importedImg6: importedImg6,
      importedImg7: importedImg7,
      importedImg8: importedImg8,
      importedImg9: importedImg9,
      importedImg10: importedImg10,
      altText: "图片",
    };
  },
  created() {
    this.gotoTop();
  },
  methods: {
    gotoTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: white;
}
/* .imgBox1 {
  margin-top: 100px;
} */
.imgBox1,
.imgBox6,
.imgBox7 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}

.imgBox2 {
  display: flex;
  justify-content: center;
  width: 100%;
}
img {
  display: block;
}
.img1,
.img6,
.img7 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}

.img2 {
  margin-left: 45px;
  margin-right: 45px;
}
.imgItem1,
.imgItem4,
.imgItem5,
.imgItem6,
.imgItem7 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}
.imgItem2 {
  max-width: 100%;
}
.imgItem2 {
  margin-top: 20px;
  margin-bottom: 100px;
}
.imgItem3 {
  margin-bottom: 100px;
}


.imgBox6 {
  display: flex;
  justify-content: center;
  background-color: #272c33;
  height: 460px; /* 固定高度 */
  min-width: 1400px;
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
}

.titlesContainer {
  display: flex;
  width: 100%;
  margin-top: 50px;
}

.titleContainer1 {
  width: 200px;
  position: absolute;
  margin-top: 30px;
  margin-left: 130px;
}
.titleContainer2 {
  margin-top: 30px;
  width: 300px;
  padding-left: 440px;
}
.titleContainer3 {
  margin-top: 30px;
  margin-left: 280px;
  width: 300px;
}
.titleContainer4 {
  margin-top: 30px;
  margin-left: 40px;
}
.subtitles {
  display: flex;
  flex-direction: column;
}

li {
  color: #ffffff;
  margin-top: 10px;
}
p {
  color: #ffffff;
  font-size: 16px;
  width: 400px;
}
.Li2 {
  width: 400px;
}
.ul1 li {
  width: 320px;
  padding-top: 10px;
}
.ul2 {
  width: 220px;
}
.ul2 li {
  width: 220px;
  padding-top: 10px;
}
.ul3 {
  width: 220px;
}
.ul3 li {
  width: 270px;
  padding-top: 10px;
}
.ul4 {
  width: 220px;
}
.ul4 li {
  width: 220px;
  padding-top: 10px;
}
.subtitles ul li.triangle::before {
  content: "";
  display: inline-block;
  width: 10px; /* 调整圆点的直径 */
  height: 10px; /* 调整圆点的直径 */
  border-radius: 50%; /* 使其成为圆形 */
  background-color: #ffffff; /* 设置圆点的颜色 */
  margin-right: 10px; /* 图标与文字之间的间距 */
}

.triangle a {
  color: #ffffff;
  text-decoration: none; /* 添加这一行，去掉下划线 */
  cursor: pointer; /* 添加这一行，显示手型光标 */
}

li {
  font-size: 14px;
}
.Li3 {
  color: #c1c0c0;
  font-size: 13px;
}
.image-row {
  display: flex;
  flex-direction: row; /* 设置水平方向排列 */
}
.a1,
.a2,
.a3,
.a4 {
  width: 300px;
  margin-top: 60px;
}
.a1 {
  margin-left: 130px;
}
a > img {
  width: 80%;
}
</style>
